import axios, { AxiosHeaders } from 'axios';
import { API_URL } from '@/app/api/constants.ts';
import { useErrorStore } from '@/app/zustand/errors.ts';
import { router } from '@/app/providers/RouterProvider';
import { authStore } from '@/app/localStorage/utils.ts';
import { handleUnauthorized } from '@/app/api/utils.ts';

const authApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

authApi.interceptors.request.use(async (config) => {
  const headers = AxiosHeaders.from(config.headers || {});
  if (headers.has('Authorization')) {
    config.headers = headers;
    return config;
  }

  const token = authStore.getToken();

  if (!token) {
    await router.navigate({ to: '/auth', replace: true });
    return config;
  }

  headers.set('Authorization', `Bearer ${token}`);
  config.headers = headers;
  return config;
});

authApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    handleUnauthorized(error);

    const message = error.response?.data?.error || error.message || error.code;
    useErrorStore.setState({ message });
    return Promise.reject(error);
  }
);

export default authApi;
